import { StyledRoomLink } from './path-outline-rooms.styles';
import { PathOutlineRoomsProps } from './path-outline-rooms.types';
export const PathOutlineRooms: React.FC<PathOutlineRoomsProps> = ({
  rooms,
  isRetired
}) => <>
    {rooms.map(({
    code,
    imageURL,
    title
  }, index) => {
    const compositeKey = `${code}-${index}`;
    return <StyledRoomLink key={compositeKey} to={`/room/${code}`} isRetired={isRetired}>
          <img data-testid="room-image" src={imageURL} alt={`Room ${title}`} />
          <span>{title}</span>
        </StyledRoomLink>;
  })}
  </>;